const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_LOADED':
			return {
				...state,
				lazyStates: {
					...state.lazyStates,
					[action.payload]: true,
				},
			};
		default:
			return state;
	}
};

export default reducer;
